import Separator from 'tailwind-components/Separator/Separator';
import ContactCard from './ContactCard';
import ExternalLinkButton from 'tailwind-components/ExternalLinkButton/ExternalLinkButton';
import CopyButton from 'tailwind-components/CopyButton/CopyButton';
import SimpleContainer from 'tailwind-components/SimpleContainer/SimpleContainer';
import HtmlContent from 'tailwind-components/HtmlContent/HtmlContent';
import React from 'react';
import propTypes from 'prop-types';

function CarrierDetail({ carrier }) {
  // united health care uses sircon credentials, so relabel the fields
  const isUnitedHealthCare = carrier.name === 'United Health Care';
  const usernameLabel = isUnitedHealthCare ? 'Sircon Username' : 'Username';
  const passwordLabel = isUnitedHealthCare ? 'Sircon Password' : 'Password';

  const topContent = (
    <>
      {carrier.description && (
        <div className='mt-1 border-t border-grey-lightest pt-2.5 first:mt-0 first:border-t-0 first:pt-0'>
          <p className='m-0 mb-1 mt-0.5 text-left text-lg font-medium tracking-wide text-black'>
            Description
          </p>
          <HtmlContent
            html={carrier.description}
            className='text-left text-md text-grey'
          />
        </div>
      )}

      {(carrier.brokerSupportNumber ||
        carrier.memberSupportNumber ||
        carrier.Broker_Support_Email ||
        carrier.Broker_Commission_Email) && (
        <div className='mt-1.5 mb-2 first:mt-0 first:border-t-0 first:pt-0'>
          <p className='m-0 mb-3 mt-3 text-left text-lg font-medium tracking-wide text-black'>
            Contact Information
          </p>
          <div className='flex flex-col gap-4'>
            {carrier.brokerSupportNumber && (
              <ContactCard
                title='Broker Support Phone'
                info={carrier.brokerSupportNumber}
              />
            )}
            {carrier.memberSupportNumber && (
              <ContactCard
                title='Member Support Phone'
                info={carrier.memberSupportNumber}
              />
            )}
            {carrier.Broker_Support_Email && (
              <ContactCard
                title='Broker Support Email'
                info={carrier.Broker_Support_Email.toLowerCase()}
                hasButton={false}
              />
            )}
            {carrier.Broker_Commission_Email && (
              <ContactCard
                title='Broker Commission Email'
                info={carrier.Broker_Commission_Email.toLowerCase()}
                hasButton={false}
              />
            )}
          </div>
        </div>
      )}

      {(carrier.username ||
        carrier.carrierBrokerPortal ||
        carrier.enrollmentPortal ||
        carrier.omWebsiteLink) && (
        <>
          <Separator variant='dashed' />
          <div className='mt-2.5 first:mt-0 first:border-t-0 first:pt-0'>
            <p className='m-0 mb-3 mt-1 text-left text-lg font-medium tracking-wide text-black'>
              External Links
            </p>
            <div className='flex flex-col gap-3'>
              <div className='flex flex-row flex-wrap gap-1'>
                {carrier.carrierBrokerPortal && (
                  <ExternalLinkButton
                    href={carrier.carrierBrokerPortal}
                    text='Broker Portal'
                    size='xsmall'
                    fill={false}
                  />
                )}
                {carrier.enrollmentPortal && (
                  <ExternalLinkButton
                    href={carrier.enrollmentPortal}
                    text='Enrollment Portal'
                    size='xsmall'
                    fill={false}
                  />
                )}
                {carrier.omWebsiteLink && (
                  <ExternalLinkButton
                    href={carrier.omWebsiteLink}
                    text='Website'
                    size='xsmall'
                    fill={false}
                  />
                )}
              </div>
              {carrier.username && carrier.password && (
                <SimpleContainer>
                  <p className='m-0 mt-1 text-lg font-semibold'>
                    Login Credentials
                  </p>
                  <CopyButton text={carrier.username} label={usernameLabel} />
                  <CopyButton text={carrier.password} label={passwordLabel} />
                </SimpleContainer>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );

  return <div className='flex flex-col gap-0'>{topContent}</div>;
}

CarrierDetail.propTypes = {
  carrier: propTypes.object.isRequired
};

export default CarrierDetail;
